import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { RoomiDialog } from 'roomi/material'
import DialogContent from '@material-ui/core/DialogContent'
import ListingSelector from '../listing-selector/listing-selector.component'
import SelectBoostPlan from '../select-boost-plan/select-boost-plan.component'
import BoostListingPayment from '../boost-listing-payment/boost-listing-payment.component'
import BoostSuccess from '../boost-success/boost-success.component'
import track from 'react-tracking'
import Listing from '../../../listings/model/listing.model'
import { insertSponsorship } from '../../actions/sponsorships.actions'
import { connect } from 'react-redux'
import text from './boost-listing-modal.text'

@track({})
@connect(null, { insertSponsorship })
class BoostListingModal extends PureComponent {
  static propTypes = {
    boostableListings: PropTypes.arrayOf(PropTypes.instanceOf(Listing))
      .isRequired,
    userId: PropTypes.string.isRequired,
    plans: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  }

  state = { error: null }
  errorRef = React.createRef()

  componentDidUpdate() {
    if (this.state.error) {
      this.errorRef.current.scrollIntoView()
    }
  }

  initialize = () => {
    const { boostableListings, plans } = this.props
    this.setState({
      step: boostableListings.length > 1 ? 0 : 1,
      selectedListing: boostableListings[0],
      selectedPlan: plans.find(plan => plan.default) || plans[0]
    })
  }

  listingSelected = selectedListing => {
    this.setState({ selectedListing })
    this.goToNextStep()
  }

  planSelected = selectedPlan => {
    this.props.tracking.trackEvent({
      action: 'Sponsorship_Listings_PlanSelected',
      details: { planId: selectedPlan.id }
    })
    this.setState({ selectedPlan })
    this.goToNextStep()
  }

  goToNextStep = () => {
    this.setState({ step: this.state.step + 1 })
  }

  goToPreviousStep = () => {
    this.setState({ step: this.state.step - 1 })
  }

  paymentSuccess = sponsorship => {
    this.setState({ sponsorship })
    this.goToNextStep()
  }

  finish = () => {
    this.props.insertSponsorship(this.state.sponsorship)
    this.props.onClose()
  }

  render() {
    const { userId, open, boostableListings, plans, onClose } = this.props
    const { step, selectedListing, selectedPlan } = this.state

    return (
      <RoomiDialog open={open} onEnter={this.initialize}>
        <DialogContent>
          {step === 0 && (
            <ListingSelector
              listings={boostableListings}
              selectedListing={selectedListing}
              onCancel={onClose}
              onSelect={this.listingSelected}
            />
          )}
          {step === 1 && (
            <SelectBoostPlan
              description={text.description}
              plans={plans}
              selectedPlan={selectedPlan}
              onCancel={onClose}
              onSelect={this.planSelected}
            />
          )}
          {step === 2 && (
            <BoostListingPayment
              userId={userId}
              selectedListing={selectedListing}
              selectedPlan={selectedPlan}
              onSuccess={this.paymentSuccess}
              onBack={this.goToPreviousStep}
            />
          )}
          {step === 3 && (
            <BoostSuccess
              successMessage={text.success}
              descriptionMessage={text.successDescription}
              duration={selectedPlan.duration}
              onClose={this.finish}
            />
          )}
        </DialogContent>
      </RoomiDialog>
    )
  }
}

export default BoostListingModal
